import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FollowUpDate = ({ values, handleChange, touched, errors, followupDate, handleFollowupDateChange }) => {
    return (
        <>
            <Form.Group>
                <Form.Label className="">
                    When should we follow up with you?
                </Form.Label>
                <DatePicker
                    className="form-control "
                    placeholderText="Select Date"
                    dateFormat="dd/MM/yyyy"
                    onChange={handleFollowupDateChange}
                    selected={followupDate}
                />
            </Form.Group>
        </>
    )
}

export default FollowUpDate;